import isSameMonth from 'date-fns/isSameMonth';
import { parseISO, parse } from 'date-fns';
import { capitalize } from 'utils/textUtils';
import { formatDate } from './formatDate';
import { getMondayOptions } from './getMondayOptions';
import { getValidFareDate } from './getValidFareDate';

export function getGroupedMondayOptions(date) {
  const options = getMondayOptions(date);
  const maxDate = getValidFareDate(date);
  const groups = [];

  options.forEach(({ value }, index) => {
    const stringToParsePattern = /\d{4}-\d{2}-\d{2}/;
    const currentDate = stringToParsePattern.test(value)
      ? parseISO(value)
      : parse(value, 'yyyy-MM-dd', new Date());

    if (currentDate <= maxDate) {
      const group = groups?.at(-1);

      const previousDate = new Date(options.at(--index)?.value);
      const createGroup = !group || !isSameMonth(currentDate, previousDate);

      if (createGroup) {
        const name = capitalize(formatDate(currentDate, 'month-and-year'));
        const dates = [
          {
            text: formatDate(currentDate, 'forward-slash'),
            value: formatDate(currentDate, 'iso-string'),
          },
        ];

        groups.push({ name, dates });

        return;
      }

      groups[groups.length - 1].dates.push({
        text: formatDate(currentDate, 'forward-slash'),
        value: formatDate(currentDate, 'iso-string'),
      });
    }
  });

  return groups;
}
